<div class="spinner" [ngClass]="{
    'spin--open': spinnerService.spinState == 'open',
    'spin--closing': spinnerService.spinState == 'closing'
  }">
  <div class="spinner-container">
    <span class="main-loading"></span>
  </div>
</div>